import { useEffect, useState } from 'react'
import { Dimensions } from 'types'
import { MAX_PREVIEW_HEIGHT, MAX_PREVIEW_WIDTH } from '../constants'

export function getPreviewDimensions(
    sourceWidth: number | undefined,
    sourceHeight: number | undefined,
    maxPreviewWidth: number = MAX_PREVIEW_WIDTH,
    fallbackDimensions?: Dimensions
) {
    if (!sourceWidth || !sourceHeight) {
        return fallbackDimensions || { height: MAX_PREVIEW_HEIGHT, width: maxPreviewWidth }
    }

    const aspectRatio = sourceWidth / sourceHeight
    let width = maxPreviewWidth
    let height = Math.round(width / aspectRatio)

    if (height > MAX_PREVIEW_HEIGHT) {
        height = MAX_PREVIEW_HEIGHT
        width = Math.round(height * aspectRatio)
    }

    return {
        height,
        width,
    }
}

export function usePreviewDimensions(
    sourceWidth: number | undefined,
    sourceHeight: number | undefined,
    maxPreviewWidth: number = MAX_PREVIEW_WIDTH,
    initialDimensions?: Dimensions
) {
    const [state, setState] = useState<Dimensions>(() =>
        getPreviewDimensions(sourceWidth, sourceHeight, maxPreviewWidth, initialDimensions)
    )

    useEffect(() => {
        setState(getPreviewDimensions(sourceWidth, sourceHeight, maxPreviewWidth, initialDimensions))
    }, [initialDimensions, maxPreviewWidth, sourceHeight, sourceWidth])

    return state
}
